export const TeacherPanelSidebarData = [
  //
  {
    title: "EMPLOYEE DETAILS",
    subNav: [
      {
        title: "DASHBOARD",
        path: "dashboard",
        cName: "sub-nav",
      },
      {
        title: "My Profile",
        path: "userProfile",
        cName: "sub-nav",
      },
      {
        title: "Policies",
        path: "policy",
        cName: "sub-nav",
      },
      {
        title: "KRA/KPI",
        path: "kraKpi",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "UPCOMING LIVE SCHEDULE",
    link: "upcomingLiveSchedule",
  },
  {
    title: "MY DAILY PLAN",
    link: "teacherTaskPlan",
  },
  {
    title: "SOLVE STUDENTS DOUBTS",
    link: "CourseSupport",
  },
  {
    title: "PENALTY",
    link: "issue",
  },
  {
    title: "STUDENTS FEEDBACK",
    link: "feedback",
  },

  // {
  //   title: "PPT FORMAT",
  //   subNav: [
  //     {
  //       title: "FOR PEN DISPLAY",
  //       path: "pptForPenDisplay",
  //       cName: "sub-nav",
  //     },
  //     {
  //       title: "FOR SMART BOARD",
  //       path: "pptForSmartBoard",
  //       cName: "sub-nav",
  //     },
  //   ],
  // },
  {
    title: "SOP",
    link: "teacherSOP",
  },
  {
    title: "ASK FOR HELP",
    link: "helpdesk",
  },
  {
    title: "SYLLABUS",
    link: "syllabusDashboard",
  },
  {
    title: "QUESTION",
    link: "question",
  },
  {
    title: "UPLOAD LIVE VIDEO",
    link: "uploadLiveVideo",
  },
  {
    title: "UPLOAD BBB / JITSI Meeting PDF",
    link: "uploadLivePDF",
  },
  {
    title: "UPLOAD RECORDED VIDEO",
    link: "uploadRecordedVideo",
  },
  {
    title: "UPLOAD TEST DISCUSSION VIDEO",
    link: "uploadTestDiscussionVideo",
  },
  {
    title: "YOUTUBE SESSION",
    subNav: [
      {
        title: "CREATE",
        path: "addTeacherYTData",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editTeacherYTData",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "QUESTION POLL",
    subNav: [
      {
        title: "CREATE",
        path: "addQuestionPoll",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editQuestionPoll",
        cName: "sub-nav",
      },
    ],
  },
  // {
  //   title: "LECTURE DELAYED",
  //   link: "lectureDelayed",
  // },
  {
    title: "QUESTION DOUBT",
    link: "questionDoubtList",
  },
  {
    title: "STUDENT ANALYSIS",
    link: "studentAnalysisDashboard",
  },
  {
    title: "SUNDAY TEST ANALYSIS",
    link: "sundayTestAnalysisDashboard",
  },
  {
    title: "STUDENT BATCH WISE RESULT",
    link: "studentBatchWiseResultDashboard",
  },
  {
    title: "TOTAL REVENUE",
    link: "totalRevenueTeacher",
  },
  {
    title: "REVENUE ANALYSIS",
    link: "revenueAnalysis",
  },
  {
    title: "SCHOLARSHIP EXAM RESULTS",
    link: "ScholarshipExamResult",
  },
   {
    title: "TEACHER PERFORMANCE",
    link: "teacherPerformance",
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
];

export const TeacherEmpPanelSidebarData = [
  {
    title: "EMPLOYEE DETAILS",
    subNav: [
      {
        title: "DASHBOARD",
        path: "dashboard",
        cName: "sub-nav",
      },
      {
        title: "My Profile",
        path: "userProfile",
        cName: "sub-nav",
      },
      {
        title: "Policies",
        path: "policy",
        cName: "sub-nav",
      },
      {
        title: "KRA/KPI",
        path: "kraKpi",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "UPCOMING LIVE SCHEDULE",
    link: "upcomingLiveSchedule",
  },
  {
    title: "MY DAILY PLAN",
    link: "teacherTaskPlan",
  },
  {
    title: "SOLVE STUDENTS DOUBTS",
    link: "CourseSupport",
  },
  {
    title: "PENALTY",
    link: "issue",
  },
  {
    title: "STUDENTS FEEDBACK",
    link: "feedback",
  },

  // {
  //   title: "PPT FORMAT",
  //   subNav: [
  //     {
  //       title: "FOR PEN DISPLAY",
  //       path: "pptForPenDisplay",
  //       cName: "sub-nav",
  //     },
  //     {
  //       title: "FOR SMART BOARD",
  //       path: "pptForSmartBoard",
  //       cName: "sub-nav",
  //     },
  //   ],
  // },
  {
    title: "SOP",
    link: "teacherSOP",
  },
  {
    title: "ASK FOR HELP",
    link: "helpdesk",
  },
  {
    title: "SYLLABUS",
    link: "syllabusDashboard",
  },
  {
    title: "QUESTION",
    link: "question",
  },
  {
    title: "UPLOAD LIVE VIDEO",
    link: "uploadLiveVideo",
  },
  {
    title: "UPLOAD BBB Meeting PDF",
    link: "uploadLivePDF",
  },
  {
    title: "UPLOAD RECORDED VIDEO",
    link: "uploadRecordedVideo",
  },
  {
    title: "UPLOAD TEST DISCUSSION VIDEO",
    link: "uploadTestDiscussionVideo",
  },
  {
    title: "YOUTUBE SESSION",
    subNav: [
      {
        title: "CREATE",
        path: "addTeacherYTData",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editTeacherYTData",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "QUESTION POLL",
    subNav: [
      {
        title: "CREATE",
        path: "addQuestionPoll",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editQuestionPoll",
        cName: "sub-nav",
      },
    ],
  },
  // {
  //   title: "LECTURE DELAYED",
  //   link: "lectureDelayed",
  // },
  {
    title: "QUESTION DOUBT",
    link: "questionDoubtList",
  },
  {
    title: "STUDENT ANALYSIS",
    link: "studentAnalysisDashboard",
  },
  {
    title: "SUNDAY TEST ANALYSIS",
    link: "sundayTestAnalysisDashboard",
  },
  {
    title: "STUDENT BATCH WISE RESULT",
    link: "studentBatchWiseResultDashboard",
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "TOTAL REVENUE",
    link: "totalRevenueTeacher",
  },
  {
    title: "REVENUE ANALYSIS",
    link: "revenueAnalysis",
  },
  {
    title: "SCHOLARSHIP EXAM RESULTS",
    link: "ScholarshipExamResult",
  },
   {
    title: "TEACHER PERFORMANCE",
    link: "teacherPerformance",
  },
];
